import { render } from "./UserPage.vue?vue&type=template&id=7a479fb1&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=7a479fb1&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a479fb1"]])

export default __exports__